export const ADD_USER_TOKEN = 'ADD_USER_TOKEN'
export const ADD_USER_DATA = 'ADD_USER_DATA'
export const SET_IS_VERIFIED = 'SET_IS_VERIFIED'
export const SET_PAYMENT_INFO = 'SET_PAYMENT_INFO'
export const SET_SELECTED_SEATSDATA = 'SET_SELECTED_SEATSDATA'
export const SET_IS_VISITED = 'SET_IS_VISITED'
export const SET_AMOUNT = 'SET_AMOUNT'